import PieChart from "../../../components/Charts/PieChart";
import { Card, Spin } from "antd";
import React, { useEffect, useState } from "react";
import "../index.css";
import { getChatSatisfaction } from "../APIs/firebaseDashboardApis";

const pieChart = {
  labels: ["Positive", "Negative", "Neutral"],
  backgroundColor: ["#7A9B00", "#EA5444", "#FFC107"],
  data: [],
  options: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: true, // Enable tooltips on hover
    },
  },
};

const SatisfactionAnalytics = ({ propertyIds, dateRange }) => {
  const [pieChartConfig, setPieChartConfig] = useState({ ...pieChart });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (propertyIds?.length > 0 && dateRange.length > 0) {
      const fetchSatisfactionCount = async () => {
        setLoading(true);
        const response = await getChatSatisfaction({ propertyIds, dateRange })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setLoading(false);
          });

        let positiveVal = 0;
        let negativeVal = 0;
        let neutralVal = 0;
        response.forEach((row) => {
          positiveVal += parseInt(row.positive) || 0;
          negativeVal += parseInt(row.negative) || 0;
          neutralVal += parseInt(row.neutral) || 0;
        });
        setPieChartConfig((prevState) => ({
          ...prevState,
          data: [positiveVal, negativeVal, neutralVal],
        }));
      };
      fetchSatisfactionCount();
    }
  }, [propertyIds, dateRange]);

  return (
    <Spin spinning={loading}>
      <Card
        style={{ height: "inherit" }}
        className="dashboard_card "
        title={
          <>
            <span className="card_title">Chat Satisfaction</span>
          </>
        }
      >
        <div className="ant-card-head">
          <PieChart
            labels={pieChartConfig.labels}
            data={pieChartConfig.data}
            backgroundColor={pieChartConfig.backgroundColor}
            options={pieChartConfig.options}
          ></PieChart>
          <br />
        </div>
      </Card>
    </Spin>
  );
};

export default React.memo(SatisfactionAnalytics);
